import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useDeviceDetect from "../hooks/useDeviceDetect";
import "./Add.css";

const AddRecord = () => {
  const [formData, setFormData] = useState({
    tracker: "FRESH",
    sjm: "Salim Al Mammari",
    journey_plane_no: "",
    journey_plane_date: "",
    scheduled_vehicle: "",
    carrier: "",
    jp_status: "IN TRANSIT",
    next_arrival_date: "",
    next_point: "",
    ivms_check_date: "",
    ivms_point: "",
    destination: "",
    offload_point: "SAS",
    driver_name: "",
    driverId: null,
    remarks: "",
    accommodation: "",
    truck_status: "LIVE",
    blue_key_name: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [driverRestStatus, setDriverRestStatus] = useState({});
  const [showRestAlert, setShowRestAlert] = useState(false);
  const [showRegisterRest, setShowRegisterRest] = useState(false);
  const [alertDriver, setAlertDriver] = useState(null);
  const [selectedDriverTemp, setSelectedDriverTemp] = useState("");
  const [showDriverDropdown, setShowDriverDropdown] = useState(false);
  const [driverSearchTerm, setDriverSearchTerm] = useState("");
  const [debouncedDriverSearch, setDebouncedDriverSearch] = useState(driverSearchTerm);
  const [driverDropdownLoading, setDriverDropdownLoading] = useState(false);
  const navigate = useNavigate();
  const { isMobile } = useDeviceDetect();

  const trackerOptions = [
    "AHMED",
    "MOHAMMED B",
    "KHALIL R",
    "MOHAMMED M",
    "MOHAMMED H",
    "KHALIL H",
    "ISSA",
    "ABDULLAH",
    "MOHANAD",
    "FRESH",
  ];

  const scheduledVehicleOptions = [
    "2135 RA",
    "2925 WA",
    "3163 DA",
    "3276 MD",
    "3425 MK",
    "391 YW",
    "3975 BM",
    "3988 YM",
    "4286 MS",
    "4833 WA",
    "4942 RK",
    "5474 RA",
    "6094 MB",
    "6369 WA",
    "6370 MD",
    "6589 DS",
    "661 WK",
    "6670 WA",
    "6741 YR",
    "7085 HW",
    "7323 YS",
    "7530 YW",
    "8331 RA",
    "8621 BK",
    "8869 BM",
    "897  MH",
    "9153 DS",
    "9497 MK",
    "YB 9942",
    "YB 5114",
    "YM 9240",
    "YD 4720",
    "YB 7666",
    "MH 6129",
    "1294 BK",
    "2355 RH",
    "9535 BA",
    "8904 RH",
    "9326 RA",
    "1023 BM",
    "9902 RH",
    "1393 BM",
    "539 MS",
    "4599 MB",
    "1572 HK",
    "9577 HA",
    "8553 AK",
    "8331 RA",
    "2603 MD",
    "6564 MD",
    "1488 BA",
    "7090 DS",
    "4623 MR",
    "7284 MK",
    "1499 YB",
    "7778 RA",
  ];

  const [dropdownData, setDropdownData] = useState({
    trackers: trackerOptions,
    sjms: [],
    scheduledVehicles: scheduledVehicleOptions,
    carriers: [],
    nextPoints: [],
    ivmsPoints: [],
    destinations: [],
    offloadPoints: [],
    accommodation: [],
    truck_status: [],
    blue_key_name: [],
  });

  const sjmOptions = useMemo(() => ["Salim Al Mammari"], []);

  const truckOptions = useMemo(() => ["Stopped", "Live"], []);
  const bluekeyoptions = useMemo(() => ["Same", "Different"], []);

  const getCurrentLocalDateTime = () => {
    const localDate = new Date();
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");
    const hours = String(localDate.getHours()).padStart(2, "0");
    const minutes = String(localDate.getMinutes()).padStart(2, "0");
    const dateTimeLocal = `${year}-${month}-${day}T${hours}:${minutes}`;
    return { dateTimeLocal };
  };

  const [activeDrivers, setActiveDrivers] = useState([]);

  const sortedActiveDrivers = useMemo(() => {
    return [...activeDrivers].sort((a, b) =>
      a.driver_name.localeCompare(b.driver_name)
    );
  }, [activeDrivers]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedDriverSearch(driverSearchTerm);
    }, 300);
    return () => clearTimeout(handler);
  }, [driverSearchTerm]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/dashboarddropdown`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const payload = response.data;
        const results = Array.isArray(payload) ? payload : payload.data || [];
        if (Array.isArray(results)) {
          setDropdownData({
            trackers: trackerOptions,
            sjms: sjmOptions,
            scheduledVehicles: scheduledVehicleOptions,
            carriers: [...new Set(results.map((item) => item.carrier))],
            nextPoints: [...new Set(results.map((item) => item.next_point))],
            ivmsPoints: [...new Set(results.map((item) => item.ivms_point))],
            destinations: [...new Set(results.map((item) => item.destination))],
            offloadPoints: [
              ...new Set(results.map((item) => item.offload_point)),
            ],
            accommodation: [
              ...new Set(results.map((item) => item.accommodation)),
            ],
            truck_status: truckOptions,
            blue_key_name: bluekeyoptions,
          });
        }

        const { dateTimeLocal } = getCurrentLocalDateTime();
        setFormData((prevState) => ({
          ...prevState,
          journey_plane_date: dateTimeLocal,
          next_arrival_date: dateTimeLocal,
          ivms_check_date: dateTimeLocal,
        }));
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchActiveDrivers = async () => {
      try {
        setDriverDropdownLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/drivers-list`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const payloadDrivers = response.data;
        const driversResults = Array.isArray(payloadDrivers)
          ? payloadDrivers
          : payloadDrivers.data || [];
        const active = (driversResults || [])
          .filter((d) => d.is_active === "Y")
          .map((d) => ({
            driver_name: (d.driver_name || "").trim(),
            reporting_driver_code: d.reporting_driver_code || "",
            driver_id: d.driver_id,
          }));
        setActiveDrivers(active);
      } catch (error) {
        setActiveDrivers([]);
      } finally {
        setDriverDropdownLoading(false);
      }
    };  

    fetchDropdownData();
    fetchActiveDrivers();
  }, [sjmOptions, truckOptions]);

  const fetchDriverRestStatus = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/driver-rest-status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const payload = response.data;
      const results = Array.isArray(payload) ? payload : payload.data || payload || {};
      if (Array.isArray(results)) {
        const map = {};
        results.forEach((d) => {
          const name = (d.driver_name || "").trim();
          map[name] = {
            needsRest: d.needs_rest === "Y" || d.needsRest === true,
            consecutiveWorkDays: d.consecutive_work_days || d.consecutiveWorkDays || 0,
            lastRestDate: d.last_rest_date || d.lastRestDate || null,
          };
        });
        setDriverRestStatus(map);
      } else {
        setDriverRestStatus(results);
      }
    } catch (error) {
      console.error("Error fetching driver rest status:", error);
    }
  }, []);

  useEffect(() => {
    fetchDriverRestStatus();
  }, [fetchDriverRestStatus]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "driver_name" && value) {
      const driverStatus = driverRestStatus[value];
      if (driverStatus?.needsRest) {
        setAlertDriver({
          name: value,
          days: driverStatus.consecutiveWorkDays,
          lastRest: driverStatus.lastRestDate,
        });
        setShowRestAlert(true);
      }
    }
  };

  const convertToUTC = (localDateTime) => {
    if (!localDateTime) return null;
    const localDate = new Date(localDateTime);
    return localDate.toISOString(); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.driver_name) {
      setMessage("Driver Name is required.");
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      setMessage("Unauthorized: Please log in.");
      return;
    }
    setSubmitting(true);
    const dataToSubmit = {
      ...formData,
      journey_plane_date: convertToUTC(formData.journey_plane_date),
      next_arrival_date: convertToUTC(formData.next_arrival_date),
      ivms_check_date: convertToUTC(formData.ivms_check_date),
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/addRecord`,
        dataToSubmit,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage(response.data.message);
      if (formData.journey_plane_no && formData.driver_name) {
        try {
          await axios.post(
            `${process.env.REACT_APP_BASE_API_URL}/api/assign-driver`,
            {
              journey_plane_no: formData.journey_plane_no,
              driver_name: formData.driver_name,
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          // Refresh driver rest status so UI reflects any changes
          if (typeof fetchDriverRestStatus === "function") {
            await fetchDriverRestStatus();
          }
        } catch (err) {
          console.error("Assign driver failed:", err?.response?.data || err.message);
          // Do not block record creation, but surface logs for debugging
        }
      }
      setTimeout(() => {
        setMessage("");
      }, 3000);
      const { dateTimeLocal } = getCurrentLocalDateTime();
      setFormData({
        tracker: "FRESH",
        sjm: "",
        journey_plane_no: "",
        journey_plane_date: dateTimeLocal,
        scheduled_vehicle: "",
        carrier: "",
        jp_status: "IN TRANSIT",
        next_arrival_date: dateTimeLocal,
        next_point: "",
        ivms_check_date: dateTimeLocal,
        ivms_point: "",
        destination: "",
        offload_point: "SAS",
        driver_name: "",
        driverId: null,
        remarks: "",
        accommodation: "",
        truck_status: "LIVE",
        blue_key_name: "",
      });
    } catch (error) {
      console.error(
        "Error details:",
        error.response ? error.response.data : error.message
      );
      setMessage(
        "Error adding record: " +
          (error.response ? error.response.data.message : "Network error.")
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleDriverSelection = () => {
    if (selectedDriverTemp) {
      const chosenDriver = sortedActiveDrivers.find(
        (d) => d.driver_name === selectedDriverTemp
      );
      if (chosenDriver) {
        setFormData((prev) => ({
          ...prev,
          driver_name: chosenDriver.driver_name,
          driverId: chosenDriver.driver_id,
        }));
        // Rest alert modal handling
        const driverStatus = driverRestStatus[chosenDriver.driver_name];
        if (driverStatus?.needsRest) {
          setAlertDriver({
            name: chosenDriver.driver_name,
            days: driverStatus.consecutiveWorkDays,
            lastRest: driverStatus.lastRestDate,
          });
          setShowRestAlert(true);
        }
      }
      setShowDriverDropdown(false);
    }
  };

  const filteredDrivers = useMemo(() => {
    const search = (debouncedDriverSearch || "").toLowerCase().trim();
    if (!search) return sortedActiveDrivers;
    return sortedActiveDrivers.filter(
      (driver) =>
        driver.driver_name.toLowerCase().includes(search) ||
        (driver.reporting_driver_code &&
          driver.reporting_driver_code.toLowerCase().includes(search))
    );
  }, [sortedActiveDrivers, debouncedDriverSearch]);

  // Rest period registration modal submit
  const handleRegisterRest = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      setMessage("Unauthorized: Please log in.");
      return;
    }
    const startDate = e.target.rest_start_date.value;
    const endDate = e.target.rest_end_date.value;
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/api/register-rest`,
        {
          driverName: alertDriver.name,
          startDate: startDate
            ? new Date(startDate).toISOString()
            : new Date().toISOString(),
          endDate: endDate ? new Date(endDate).toISOString() : null,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setShowRegisterRest(false);
      setAlertDriver(null);
      setMessage("Rest period registered successfully!");
    } catch (error) {
      setShowRegisterRest(false);
      setAlertDriver(null);
      setMessage("Failed to register rest period.");
    }
  };

  return (
    <div className={`containeradd ${isMobile ? "mobile" : "desktop"}`}>
      <button className="close-button" onClick={() => navigate("/main")}>
        ×
      </button>
      {loading ? (
        <div>Loading dropdown data...</div>
      ) : (
        <form onSubmit={handleSubmit} className="form-grid mannual_form_grid">
          <div className="block-display">
            <label className="form-label-addrecord">
              Journey Plan No <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-input-addrecord"
              name="journey_plane_no"
              value={formData.journey_plane_no}
              onChange={handleChange}
              list="journey-list"
              required
            />
          </div>
          <div>
            <label className="form-label-addrecord">
              Journey Plan Date & Time <span className="required">*</span>
            </label>
            <input
              type="datetime-local"
              className="form-input-addrecord"
              name="journey_plane_date"
              value={formData.journey_plane_date}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label className="form-label-addrecord">Journey Plan Status</label>
            <select
              className="form-input-addrecord form-select-addrecord"
              name="jp_status"
              value={formData.jp_status}
              onChange={handleChange}
            >
              <option value="">Select Status</option>
              <option value="IN TRANSIT">IN TRANSIT</option>
              <option value="CLOSED">CLOSED</option>
            </select>
          </div>
          <div>
            <label className="form-label-addrecord">
              Scheduled Vehicle <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-input-addrecord dropdown-input"
              name="scheduled_vehicle"
              value={formData.scheduled_vehicle}
              onChange={handleChange}
              list="scheduled-vehicle-list"
              required
              autoComplete="off"
            />
            <datalist id="scheduled-vehicle-list">
              {dropdownData.scheduledVehicles.map((vehicle, index) => (
                <option key={index} value={vehicle} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">
              Carrier <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-input-addrecord dropdown-input"
              name="carrier"
              value={formData.carrier}
              onChange={handleChange}
              list="carrier-list"
              required
              autoComplete="off"
            />
            <datalist id="carrier-list">
              {dropdownData.carriers.map((carrier, index) => (
                <option key={index} value={carrier} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">Next Point</label>
            <input
              type="text"
              className="form-input-addrecord dropdown-input"
              name="next_point"
              value={formData.next_point}
              onChange={handleChange}
              list="next-point-list"
              autoComplete="off"
            />
            <datalist id="next-point-list">
              {dropdownData.nextPoints.map((point, index) => (
                <option key={index} value={point} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">
              Next Arrival Date & Time
            </label>
            <input
              type="datetime-local"
              className="form-input-addrecord"
              name="next_arrival_date"
              value={formData.next_arrival_date}
              onChange={handleChange}
            />
          </div>
          <div>
            <label className="form-label-addrecord">IVMS Point</label>
            <input
              type="text"
              className="form-input-addrecord dropdown-input"
              name="ivms_point"
              value={formData.ivms_point}
              onChange={handleChange}
              list="ivms-point-list"
              autoComplete="off"
            />
            <datalist id="ivms-point-list">
              {dropdownData.ivmsPoints.map((point, index) => (
                <option key={index} value={point} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">
              IVMS Check Date & Time
            </label>
            <input
              type="datetime-local"
              className="form-input-addrecord"
              name="ivms_check_date"
              value={formData.ivms_check_date}
              onChange={handleChange}
            />
          </div>
          <div>
            <label className="form-label-addrecord">
              Offload Point <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-input-addrecord dropdown-input"
              name="offload_point"
              value={formData.offload_point}
              onChange={handleChange}
              list="offload-point-list"
              required
              autoComplete="off"
            />
            <datalist id="offload-point-list">
              {dropdownData.offloadPoints.map((point, index) => (
                <option key={index} value={point} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">Destination</label>
            <input
              type="text"
              className="form-input-addrecord dropdown-input"
              name="destination"
              value={formData.destination}
              onChange={handleChange}
              list="destination-list"
              autoComplete="off"
            />
            <datalist id="destination-list">
              {dropdownData.destinations.map((destination, index) => (
                <option key={index} value={destination} />
              ))}
            </datalist>
          </div>
          <div className="driver-select-container">
            <label className="form-label-addrecord">
              Driver Name <span className="required">*</span>
            </label>
            <div className="custom-dropdown">
              <input
                type="text"
                className="form-input-addrecord"
                value={formData.driver_name}
                onClick={() => setShowDriverDropdown(true)}
                readOnly
                placeholder="Click to select driver"
              />
              {showDriverDropdown && (
                <div className="driver-dropdown-menu">
                  <div className="driver-search-box">
                    <input
                      type="text"
                      placeholder="Search driver..."
                      value={driverSearchTerm}
                      onChange={(e) => setDriverSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      className="driver-search-input"
                    />
                  </div>
                  <div className="driver-options-container">
                    {driverDropdownLoading ? (
                      <div className="driver-loading">Loading drivers...</div>
                    ) : filteredDrivers.length > 0 ? (
                      filteredDrivers.map((driver, index) => (
                        <div
                          key={index}
                          className={`driver-option ${
                            selectedDriverTemp === driver.driver_name
                              ? "selected"
                              : ""
                          }`}
                          onClick={() =>
                            setSelectedDriverTemp(driver.driver_name)
                          }
                        >
                          <div className="driver-name">
                            {driver.driver_name}
                          </div>
                          {driver.reporting_driver_code && (
                            <div className="driver-code">
                              ({driver.reporting_driver_code})
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="no-results">No drivers found</div>
                    )}
                  </div>
                  <div className="driver-dropdown-actions">
                    <button
                      type="button"
                      className="driver-select-btn"
                      onClick={handleDriverSelection}
                    >
                      OK
                    </button>
                    <button
                      type="button"
                      className="driver-cancel-btn"
                      onClick={() => {
                        setShowDriverDropdown(false);
                        setDriverSearchTerm("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div>
            <label className="form-label-addrecord">Accommodation</label>
            <input
              type="text"
              className="form-input-addrecord"
              name="accommodation"
              value={formData.accommodation}
              onChange={handleChange}
              list="accommodation-list"
            />
            <datalist id="accommodation-list">
              {dropdownData.accommodation.map((accommodation, index) => (
                <option key={index} value={accommodation} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">
              Sr. Journey Manager <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-input-addrecord"
              name="sjm"
              value={formData.sjm}
              onChange={handleChange}
              list="sjm-list"
              required
            />
            <datalist id="sjm-list">
              {sjmOptions.map((sjm, index) => (
                <option key={index} value={sjm} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">Truck Status</label>
            <input
              type="text"
              className="form-input-addrecord"
              name="truck_status"
              value={formData.truck_status}
              onChange={handleChange}
              list="truckStatus-list"
            />
            <datalist id="truckStatus-list">
              {truckOptions.map((truck_status, index) => (
                <option key={index} value={truck_status} />
              ))}
            </datalist>
          </div>
          <div>
            <label className="form-label-addrecord">Tracker</label>
            <input
              type="text"
              className="form-input-addrecord"
              name="tracker"
              value={formData.tracker}
              onChange={handleChange}
              list="tracker-list"
            />
            <datalist id="tracker-list">
              {trackerOptions.map((tracker, index) => (
                <option key={index} value={tracker} />
              ))}
            </datalist>
          </div>
          {/* <div>
            <label className="form-label-addrecord">Blue Key Name</label>
            <input
              type="text"
              className="form-input-addrecord"
              name="blue_key_name"
              value={formData.blue_key_name}
              onChange={handleChange}
              list="blue_key_name-list"
            />
            <datalist id="blue_key_name-list">
              {bluekeyoptions.map((blue_key_name, index) => (
                <option key={index} value={blue_key_name} />
              ))}
            </datalist>
          </div> */}
          <button
            type="submit"
            disabled={submitting}
            className="submit-button-addrecord"
          >
            {submitting ? "Submitting..." : "Add Record"}
          </button>
          {message && <div className="message-addrecord">{message}</div>}
        </form>
      )}
      {/* Rest Alert Modal */}
      {showRestAlert && alertDriver && (
        <div className="addrecord-modal-backdrop">
          <div
            className="addrecord-modal-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="restAlertTitle"
            tabIndex={-1}
          >
            <header className="addrecord-modal-header">
              <h2 id="restAlertTitle">
                <span role="img" aria-label="warning">
                  ⚠️
                </span>{" "}
                Driver Rest Alert
              </h2>
              <button
                className="addrecord-modal-close-btn"
                aria-label="Close"
                onClick={() => {
                  setShowRestAlert(false);
                  setAlertDriver(null);
                }}
              >
                &times;
              </button>
            </header>
            <main className="addrecord-modal-body">
              <p>
                <strong>{alertDriver.name}</strong> has been working for{" "}
                <strong>{alertDriver.days}</strong> consecutive days
                {alertDriver.lastRest && (
                  <>
                    {" "}
                    and last rested on{" "}
                    <time
                      dateTime={new Date(alertDriver.lastRest).toISOString()}
                    >
                      {new Date(alertDriver.lastRest).toLocaleDateString()}
                    </time>
                    .
                  </>
                )}
              </p>
              <p>
                According to safety regulations, the driver must take a rest
                period to ensure compliance and wellbeing.
              </p>
              <p>Do you want to register a rest period now for this driver?</p>
            </main>
            <footer className="addrecord-modal-footer">
              <button
                className="addrecord-modal-btn-primary"
                onClick={() => {
                  setShowRegisterRest(true);
                  setShowRestAlert(false);
                }}
              >
                Register Rest
              </button>
              <button
                className="addrecord-modal-btn-secondary"
                onClick={() => {
                  setShowRestAlert(false);
                  setAlertDriver(null);
                }}
              >
                Proceed Without Rest
              </button>
              <button
                className="addrecord-modal-btn-secondary"
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    driver_name: "",
                    driverId: null,
                  }));
                  setShowRestAlert(false);
                  setAlertDriver(null);
                }}
              >
                Select Different Driver
              </button>
            </footer>
          </div>
        </div>
      )}
      {/* Register Rest Modal */}
      {showRegisterRest && alertDriver && (
        <div className="addrecord-modal-backdrop">
          <div
            className="addrecord-modal-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <header className="addrecord-modal-header">
              <h2>Register Driver Rest</h2>
              <button
                className="addrecord-modal-close-btn"
                aria-label="Close"
                onClick={() => {
                  setShowRegisterRest(false);
                  setAlertDriver(null);
                }}
              >
                &times;
              </button>
            </header>
            <form onSubmit={handleRegisterRest}>
              <div>
                <label>Driver Name</label>
                <input value={alertDriver.name} readOnly />
              </div>
              <div>
                <label>Rest Start Date & Time</label>
                <input
                  type="datetime-local"
                  name="rest_start_date"
                  defaultValue={getCurrentLocalDateTime().dateTimeLocal}
                  required
                />
              </div>
              <div>
                <label>Rest End Date & Time (optional)</label>
                <input type="datetime-local" name="rest_end_date" />
              </div>
              <div style={{ marginTop: "16px" }}>
                <button type="submit">Register Rest</button>
                <button
                  type="button"
                  onClick={() => {
                    setShowRegisterRest(false);
                    setAlertDriver(null);
                  }}
                  style={{ marginLeft: "8px" }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRecord;
